import React, { useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Productions } from './components/Productions';
import { Biography } from './components/Biography';
import { About } from './components/About';
import { Booking } from './components/Booking';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { LegalModal, type LegalDoc } from './components/LegalModal';
import { WhatsappFloat } from './components/WhatsappFloat';
export function App() {
  const [legalDoc, setLegalDoc] = useState<LegalDoc | null>(null);
  return <div className="min-h-screen w-full bg-ink text-white" data-id="element-0" data-mp="31ctaxf1x1e2u">
      <Header data-id="element-1" data-mp="2wj8cjlweui34" />
      <main data-id="element-2" data-mp="2wifbn1k4umsw">
        <Hero data-id="element-3" data-mp="2whx95n6vnccj" />
        <Services data-id="element-4" data-mp="28ufpkexrnkkn" />
        <Productions data-id="element-5" data-mp="28tw62tsgwo4i" />
        <Biography data-id="element-6" data-mp="28te2fc3h77mk" />
        <About data-id="element-7" data-mp="28suv0pbgc1ms" />
        <Booking data-id="element-8" data-mp="28sb9kymlev40" />
        <Faq data-id="element-9" data-mp="23vchsmqej08z" />
      </main>
      <Footer onOpenLegal={setLegalDoc} data-id="element-10" data-mp="23w4g45bdvc2y" />
      <WhatsappFloat data-id="element-11" data-mp="23v2tr4ox335x" />
      <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} data-id="element-12" data-mp="3ijxpcqos80jw" />
    </div>;
}